const PropTypes = require('prop-types');

const LD_JSON_TYPE = 'application/ld+json';

const ALLOWED_CROSSORIGIN = /** @type {const} */ ([
  'anonymous',
  'use-credentials',
  '',
  null,
]);

const ALLOWED_REFERRERPOLICY = /** @type {const} */ ([
  'no-referrer',
  'no-referrer-when-downgrade',
  'origin',
  'origin-when-cross-origin',
  'unsafe-url',
  'same-origin',
  'strict-origin',
  'strict-origin-when-cross-origin',
  '',
]);

const ALLOWED_PLACEMENTS = /** @type {const} */ (['now', 'load']);

const ALLOWED_SHEDULER_PRIORITIES = /** @type {const} */ ([
  'user-blocking',
  'user-visible',
  'background',
]);

/** @type {React.WeakValidationMap<import('../../index.d.ts').ScriptProps>} */
const SCRIPT_PROP_TYPES = {
  // Native script props
  async: PropTypes.bool,
  crossOrigin: PropTypes.oneOf(ALLOWED_CROSSORIGIN),
  referrerPolicy: PropTypes.oneOf(ALLOWED_REFERRERPOLICY),
  type: PropTypes.string,

  // Native html props
  id: PropTypes.string,

  // Custom Props
  // @ts-expect-error There's no way of modelling wither src or children as required
  src: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  ]),
  inline: PropTypes.bool,
  on: PropTypes.oneOf(ALLOWED_PLACEMENTS),
  preload: PropTypes.bool,
  priority: PropTypes.number,
  // @ts-expect-error PropTypes.shape adds 'null' as a possible type and collides with TS defs
  scheduler: PropTypes.shape({
    priority: PropTypes.oneOf(ALLOWED_SHEDULER_PRIORITIES),
    delay: PropTypes.number,
  }),
};

module.exports = {
  LD_JSON_TYPE,
  SCRIPT_PROP_TYPES,
  ALLOWED_PLACEMENTS,
};
